export default "__VITE_ASSET__368b0bbd__"